var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        Evidence of Insurance Status\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('p', [_vm._v("Your Evidence of Insurance is ready for download. Provide this form as Evidence of Homeowners Insurance to your bank as needed for your mortage banking needs.")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-centered"
  }, [_c('a', {
    attrs: {
      "href": "/static/ACCORD-EOI.pdf"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("ACOORD-EOI.pdf")])])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b9ad91","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/request/Status.vue
// module id = t5b5
// module chunks = 1